import styled from 'styled-components'
import Icon from 'antd/lib/icon'
import { GRAY_DARK } from '../../theme/colors'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100vh;
`

export const Text = styled.div`
  color: ${GRAY_DARK};
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const AlertIcon = styled(Icon).attrs({
  type: 'alert'
})`
  font-size: 16px;
`

export const ButtonContainer = styled.div`
  margin-top: 20px;
`

export const Error404 = styled.p`
  font-size: 20px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/NotFound/styledComponents.tsx